/**
 * Public, org-scoped Datadog browser client token — safe to inline in the shipped bundle, and
 * safe to put in a response header. It authorises the browser intake only (RUM, Browser Logs and
 * the CSP report endpoint); it grants no read access. Reused as-is from apps/health and
 * apps/atlas-mcp, which use the same token with a different `service` tag.
 *
 * Lives in its own import-free module rather than in `app/instrumentation.client.ts` because two
 * very different consumers need it and it must not be able to drift between them:
 * `instrumentation.client.ts` initialises the browser SDKs with it, and
 * `app/content-security-policy.ts` builds the `report-uri` intake URL from it — the latter is
 * read at deploy time by `sst.config.ts`, which cannot import a `*.client.ts` module (those read
 * `import.meta.env`, which does not exist outside the Vite build).
 */
export const DD_CLIENT_TOKEN = 'pubd6e945d1071ed0afa4ecd31d7739a98c'
